// Lifecycle of a Telegram user session (public.tg_sessions.status). Written only by
// core, from what tg-client reports at each login step and at runtime — never by a
// cabinet save, so the grid shows it read-only.
export const TG_SESSION_STATUS = [
    'new',
    'awaiting_code',
    'awaiting_password',
    'active',
    'logged_out',
    'error'
];

// Outcome of a message (public.tg_session_messages.status). Inbound rows go
// received -> processed | unmatched | ambiguous | ignored | failed; outbound rows
// are sent or failed.
export const TG_SESSION_MESSAGE_STATUS = [
    'received',
    'processed',
    'unmatched',
    'ambiguous',
    'ignored',
    'failed',
    'sent'
];

export const TG_MESSAGE_DIRECTION = ['in', 'out'];
